import React, { useState } from 'react';

import { useUserPermission } from '@contexts/UserContext';

import Comments from '@components/Comments/Comments';
import { NwAddButton } from '@components/Gui/NwButton';
import { NwCard } from '@components/Gui/NwCard/NwCard';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const ModelDetailsComments = ({ currentContact, drawerMode, ...rest }) => {
    const [createComments, setCreateComments] = useState(false);
    const viewModelComments = useUserPermission(
        'ViewModelComments',
        currentContact && currentContact.Users.map((user) => user.UserID)
    );
    const afterCommentsCreation = () => {
        setCreateComments(false);
    };

    return (
        <NwCard
            fullheight
            title="Comments"
            icon={byPrefixAndName.fasl['comments']}
            padding={'no-padding'}
            extra={
                <NwAddButton
                    ghost
                    disabled={!viewModelComments}
                    size="small"
                    onClick={() => {
                        setCreateComments(true);
                    }}
                    label="add new"
                />
            }
        >
            <Comments
                isInCardTab
                api="ContactID"
                drawerMode
                contactId={currentContact.ID}
                ID={currentContact.ID}
                comments={currentContact.Comments}
                createComments={createComments}
                afterCommentsCreation={afterCommentsCreation}
            />
        </NwCard>
    );
};

export default ModelDetailsComments;
